import { ReactElement, useCallback, useEffect, useState } from 'react';

import { useConnection } from 'modules/auth/hooks/useConnection';
import { KnownDialogs, useDialog } from 'modules/dialogs';
import { UnstakeSuccessDialog } from 'modules/liquidStaking/components/UnstakeSuccessDialog/UnstakeSuccessDialog';
import {
  EMPTY_MODAL_UNSTAKE_SUCCESS_STATE,
  UnstakeType,
} from 'modules/liquidStaking/const';
import { useLiquidStakingPool } from 'modules/liquidStaking/hooks/useLiquidStakingPool';
import { useUnstakeAction } from 'modules/liquidStaking/hooks/useUnstakeAction';
import { IModalUnstakeSuccessState } from 'modules/liquidStaking/types';

import { IUnstakeFormProps, UnstakeForm } from './UnstakeForm';

export function Unstake(): ReactElement | null {
  const { isDeprecated } = useLiquidStakingPool();
  const [successState, setSuccessState] = useState<IModalUnstakeSuccessState>(
    EMPTY_MODAL_UNSTAKE_SUCCESS_STATE,
  );
  const { isSafeAccount } = useConnection();

  const { unstake, isLoading, reset, setType, type, txHash } =
    useUnstakeAction();

  const [formKey, setFormKey] = useState(0);
  const handleReset = useCallback(() => {
    reset();
    setFormKey(prev => prev + 1);
    setType(isDeprecated ? UnstakeType.Unstake : UnstakeType.FlashUnstake);
    setSuccessState(EMPTY_MODAL_UNSTAKE_SUCCESS_STATE);
  }, [isDeprecated, reset, setType]);

  const { onOpen, isOpened } = useDialog<IModalUnstakeSuccessState>(
    KnownDialogs.tabUnstakeSuccess,
  );
  useEffect(() => {
    if (!isLoading && txHash && !isOpened && !isSafeAccount) {
      onOpen({ ...successState, txHash, type });
    }
  }, [txHash, isLoading, isOpened, onOpen, successState, type, isSafeAccount]);

  const handleSubmit: IUnstakeFormProps['onSubmit'] = useCallback(
    async ({ amount, receiveAmount }) => {
      await unstake(amount);
      setSuccessState({ inAmount: amount, outAmount: receiveAmount, type });
    },
    [type, unstake],
  );

  return (
    <>
      <UnstakeForm
        key={formKey}
        isSubmitLoading={isLoading}
        setType={setType}
        type={type}
        onSubmit={handleSubmit}
      />

      {isOpened && <UnstakeSuccessDialog onClose={handleReset} />}
    </>
  );
}
